import { render, staticRenderFns } from "./agentPublishesNoticeEdit.vue?vue&type=template&id=0f9fdd68&scoped=true"
import script from "./agentPublishesNoticeEdit.vue?vue&type=script&lang=js"
export * from "./agentPublishesNoticeEdit.vue?vue&type=script&lang=js"
import style0 from "./agentPublishesNoticeEdit.vue?vue&type=style&index=0&id=0f9fdd68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9fdd68",
  null
  
)

export default component.exports